import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { fill_action } from "../../../actions/fillList_action";
import Loader from "../../../utils/Loader";
import Resizer from "react-image-file-resizer";
import {
  accountTypeActionId,
  cityActionId,
  companyStatusActionId,
  countryActionId,
  externalServicesActionId,
  sessionExpireMessage,
  stateActionId,
  toastError,
  tokenInavlidMessage,
} from "../../../utils/constants";
import {
  emailValidator,
  panNoValidator,
  pincodeValidator,
  mobileNoValidator,
  passwordValidator,
  confirmPasswordValidator,
} from "../../../utils/Validator";
import Select from "react-select";
import Header from "../../../common_components/Header";
import {
  vendor_add_action,
  vendor_detail_action,
  vendor_delete_action,
} from "../../../actions/master_actions/vendor_action";
import { Button, Modal } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#c9c9c9", // Blue border color
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff", // Blue border color on hover
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "14px",
    textAlign: "center",
    padding: "4px",
    backgroundColor: "#00BCD4", // Blue background color for selected value
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white", // Text color for selected value
    fontSize: "12px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "white",
    "&:hover": {
      backgroundColor: "#00BCD4",
      color: "#fff", // Blue border color on hover
    },
  }),
};

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_PREVIEW_COUNT = 10;
class VendorAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //modal
      showDetails: false,
      showPackageDetails: "",
      showImg: false,
      show: false,
      //rest
      isLoading: false,
      checkboxFlag: false,
      stateId: "",
      stateList: [],
      countryId: "",
      VendorID: "",
      countryList: [],
      firstName: "",
      lastName: "",
      designation: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      cityId: "",
      cityList: [],
      pincode: "",
      Mobile1: "",
      Mobile2: "",
      primaryEmailID: "",
      secondaryEmailID: "",
      website: "",
      mobileISD1: "",
      mobileISD2: "",
      accountType: "",
      accountTypeList: [],
      registrationNumber: "",
      PANCardNo: "",
      NameonPANCard: "",
      GSTNo: "",
      CompanyStatus: "",
      TANNumber: "",
      UINNumber: "",
      TelephoneNumber: "",

      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
      companyStatusId: "",
      CityName: "",
      tempCityList: [],
      companyStatusList: [],
      ISD: "",

      VendorID: "",
      MaxPAX: "",
      LastDate: "",

      // input validate
      companyStatusErr: "",
      firstNameErr: "",
      lastNameErr: "",
      VendorErr: "",
      addressLine1Err: "",
      addressLine2Err: "",
      CityNameErr: "",
      countryIdErr: "",
      pincodeErr: "",
      Mobile1Err: "",
      primaryEmailIDErr: "",
      PANCardNoErr: "",
      NameonPANCardErr: "",
      accountNameErr: "",
      accountNoErr: "",
      accountTypeErr: "",
      bankNameErr: "",
      branchNameErr: "",
      IFSCCodeErr: "",

      isDisplayCityList: false,

      isDisplayStateList: false,
      tempStateList: [],

      TypeOfEventList: [],
      editIndex: "",
      editedRowIndexServicePackage: "",
      editedRowServicePackage: "",
      servicePackageList: [],
      servicePackageDetails: {
        VendorServicePackageID: null,
        ServiceID: "",
        City: "",
        Package: "",
        PackageDetails: "",
        ITME_Margin: "",
        packageValue: "",
        previewImagesInput: [],
      },
      VendorServicePackageImageID: "",
      FilePath: [],
      previewImagesInput: [],
      servicePhotoList: [],
      //nodeimage
      packageImageList: [],
      formFile: "",
      fileName: "",
      formFileType: "",
      VendorServicePackageID: null,
      ServiceID: "",
      City: "",
      Package: "",
      PackageDetails: "",
      Price_In_INR: "",
      Price_In_USD: "",
      ITME_CutOff_Limit: "",
      ITME_Margin: "",
      password: "",
      confPassword: "",
      passwordErr: "",
      confPasswordErr: "",
      ExternalServicesID: "",
      VendorServiceID: "",
      ExternalServices: "",
      ExternalServicesList: [],
      ExternalServicesListTable: [],
      vendorServiceList: [],
      StatusID: "",
      materialList: [],
      materialDetails: {
        VendorServicesMaterialID: "",
        Name: "",
        ServiceID: "",
        Quantity: "",
        IsActive: 1,
      },
      showNewRowMaterial: false,
      editedRowIndexMaterial: null,
      editedRowDataMaterial: {},
    };
    this.vendorDetails = this.vendorDetails.bind(this);
    this.navigateBackVendorList = this.navigateBackVendorList.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
      setTimeout(() => {
        {
          sessionStorage.getItem("roleId") == 4 ? (
            this.props.navigate("/checkList")
          ) : (
            <></>
          );
        }
      }, 10);
    }
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      StatusID: this.props.location.state?.StatusID
        ? this.props.location.state?.StatusID
        : "",
    });
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    console.log("Props received:", this.props);
    console.log("Props.location.state received:", this.props.location.state);

    const VendorID = this.props.location.state?.VendorID || "";
    console.log("VendorID:", VendorID);

    this.getFillList(stateActionId, "", "", "");
    this.getFillList(countryActionId, "", "", "");
    this.getFillList(cityActionId, "", "", "");
    this.getFillList(companyStatusActionId, "", "", "");
    this.getFillList(accountTypeActionId, "", "", "");
    this.getFillList(externalServicesActionId, "", "", "", "");

    if (VendorID) {
      this.setState({ VendorID }, () => {
        this.vendorDetails();
      });
    }
  }

  getFillList(value, userID, keyword, keyvalue) {
    // this.setState({ isLoading: true })
    this.props
      .fill_action(
        value,
        userID == "" || userID == null ? null : userID,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == stateActionId) {
            this.setState({
              stateList: data.data,
              tempStateList: data.data,
            });
          }
          if (value == countryActionId) {
            this.setState({
              countryList: data.data,
              isLoading: false,
              countryId: 91,
              ISD: 91,
            });
          }
          if (value == cityActionId) {
            this.setState({
              cityList: data.data,
              tempCityList: data.data,
            });
          }
          if (value == companyStatusActionId) {
            this.setState({ companyStatusList: data.data, isLoading: false });
          }
          if (value == accountTypeActionId) {
            this.setState({ accountTypeList: data.data, isLoading: false });
          }
          if (value == externalServicesActionId) {
            var tempExtServArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var extSerObj = {};
              extSerObj.label = data.data[i].ExternalServices;
              extSerObj.value = data.data[i].ExternalServicesID;
              tempExtServArr.push(extSerObj);
            }
            this.setState({
              ExternalServicesList: tempExtServArr,
              isLoading: false,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // search city
  onCitytSearch(e) {
    const { cityList, tempCityList, billTempCityList, cityId, countryId } =
      this.state;
    if (e.target.value != "") {
      var searchCityList = tempCityList.filter((data) => {
        return data.CityName.toLowerCase().includes(
          e.target.value.toLowerCase()
        );
      });
      this.setState({
        cityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        CityNameErr: "",
        tempCityList: searchCityList,
        isDisplayCityList: true,
      });
    } else {
      this.setState({
        cityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        tempCityList: cityList,
        isDisplayCityList: false,
      });
    }
  }

  // render city
  mainCityListData(data) {
    this.setState({
      cityId: data.CityName,
      isDisplayCityList: false,
      CityNameErr: "",
    });
  }
  renderCityList() {
    const { tempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempCityList.length > 0 &&
          tempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainCityListData(data)}
            >
              {data.CityName}
            </li>
          ))}
      </ul>
    );
  }

  // same as above search city

  // search State
  onStateSearch(e) {
    const { stateList, tempStateList, countryId } = this.state;
    console.log("countryId -------------------onStateSearch", countryId);
    if (e.target.value != "") {
      var searchStateList = tempStateList.filter((data) => {
        return data.Description.toLowerCase().includes(
          e.target.value.toLowerCase()
        );
      });
      this.setState({
        stateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        stateErr: "",
        tempStateList: searchStateList,
        isDisplayStateList: true,
      });
    } else {
      this.setState({
        stateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        stateErr: "",
        tempStateList: stateList,
        isDisplayStateList: false,
      });
    }
  }
  // render State
  renderStateList() {
    const { tempStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempStateList.length > 0 &&
          tempStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainStateListData(data)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  mainStateListData(data) {
    this.setState({
      stateId: data.Description,
      isDisplayStateList: false,
      stateErr: "",
    });
  }

  inputValidate() {
    const {
      firstName,
      lastName,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      cityId,
      pincode,
      Mobile1,
      primaryEmailID,
      PANCardNo,
      NameonPANCard,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      countryId,
      password,
      confPassword,
    } = this.state;

    console.log("*******************", stateId);

    if (firstName == "" || firstName == null) {
      this.setState({ firstNameErr: "Please enter first name" });
    }
    if (lastName == "" || lastName == null) {
      this.setState({ lastNameErr: "Please enter last name" });
    }
    if (companyName == "" || companyName == null) {
      this.setState({ VendorErr: "Please enter Vendor name" });
    }
    if (addressLine1 == "" || addressLine1 == null) {
      this.setState({ addressLine1Err: "Please enter address line 1" });
    }
    if (addressLine2 == "" || addressLine2 == null) {
      this.setState({ addressLine2Err: "Please enter address line 2" });
    }
    if (cityId == "" || cityId == null) {
      this.setState({
        CityNameErr: "Please enter city",
        isDisplayCityList: false,
      });
    }
    if (stateId == "" || stateId == null) {
      this.setState({ stateErr: "Please select state" });
    }

    if (pincode == "" || pincode == null) {
      this.setState({ pincodeErr: "Please enter pincode" });
    }
    if (Mobile1 == "" || Mobile1 == null) {
      this.setState({ Mobile1Err: "Please enter mobile number" });
    }
    if (primaryEmailID == "" || primaryEmailID == null) {
      this.setState({ primaryEmailIDErr: "Please enter email id" });
    }
    if (PANCardNo == "" || PANCardNo == null) {
      this.setState({ PANCardNoErr: "Please enter pancard number" });
    }
    if (NameonPANCard == "" || NameonPANCard == null) {
      this.setState({ NameonPANCardErr: "Please enter name on pancard" });
    }
    if (accountName == "" || accountName == null) {
      this.setState({ accountNameErr: "Please enter account name" });
    }
    if (accountNo == "" || accountNo == null) {
      this.setState({ accountNoErr: "Please enter account number" });
    }
    if (
      accountType == "" ||
      accountType == "Select" ||
      accountType == "Account Type*" ||
      accountType == null
    ) {
      this.setState({ accountTypeErr: "Please select account type" });
    }
    if (bankName == "" || bankName == null) {
      this.setState({ bankNameErr: "Please enter bank name" });
    }
    if (branchName == "" || branchName == null) {
      this.setState({ branchNameErr: "Please enter branch name" });
    }
    if (IFSCCode == "" || IFSCCode == null) {
      this.setState({ IFSCCodeErr: "Please enter IFSC code" });
    }
    if (password == "" || password == null) {
      this.setState({ passwordErr: "Please enter Password" });
    }
    if (confPassword == "" || confPassword == null) {
      this.setState({ confPasswordErr: "Please enter Confirm Password" });
    }
  }

  firstName(e) {
    const inputValue = e.target.value;
    // Regex pattern to allow only alphabetic characters
    const regex = /^[a-zA-Z\s]*$/;
    // Check if the input value matches the pattern
    if (regex.test(inputValue)) {
      this.setState({
        firstName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        firstNameErr: "",
      });
    } else {
      toast.error("Numbers not allowed", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
      });
    }
  }

  lastName(e) {
    const inputValue = e.target.value;
    // Regex pattern to allow only alphabetic characters
    const regex = /^[a-zA-Z\s]*$/;
    // Check if the input value matches the pattern
    if (regex.test(inputValue)) {
      this.setState({
        lastName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        lastNameErr: "",
      });
    } else {
      toast.error("Numbers not allowed", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
      });
    }
  }

  designation(e) {
    this.setState({
      designation: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
    });
  }

  VendorName(e) {
    this.setState({
      companyName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      VendorErr: "",
    });
  }

  addressLine1(e) {
    this.setState({
      addressLine1: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine1Err: "",
    });
  }

  addressLine2(e) {
    this.setState({
      addressLine2: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine2Err: "",
    });
  }

  pincode(e) {
    this.setState({
      pincode: e.target.value.replace(/\D/, ""),
      pincodeErr: "",
    });
  }

  mobile1(e) {
    this.setState({
      Mobile1: e.target.value.replace(/\D/, ""),
      Mobile1Err: "",
    });
  }

  mobile2(e) {
    this.setState({ Mobile2: e.target.value.replace(/\D/, "") });
  }

  telephone(e) {
    this.setState({ TelephoneNumber: e.target.value.replace(/\D/, "") });
  }

  primaryEmail(e) {
    this.setState({ primaryEmailID: e.target.value, primaryEmailIDErr: "" });
  }

  secondaryEmail(e) {
    this.setState({ secondaryEmailID: e.target.value });
  }

  website(e) {
    this.setState({ website: e.target.value });
  }
  password(e) {
    this.setState({
      password: e.target.value,
      passwordErr: "",
    });
  }
  confPassword(e) {
    this.setState({
      confPassword: e.target.value,
      confPasswordErr: "",
    });
  }
  navigateBackVendorList() {
    this.props.navigate("/vendor");
  }
  clearFields() {
    this.setState({
      VendorID: "",
      FirstName: "",
      LastName: "",
      Designation: "",
      CompanyName: "",
      AddressLine1: "",
      AddressLine2: "",
      CityID: "",
      StateID: "",
      Countryid: "",
      Pincode: "",
      Mobile1: "",
      Mobile2: "",
      Telephone: "",
      PrimaryEmailID: "",
      SecondaryEmailID: "",
      Website: "",
      CompanyRegistrationNo: "",
      PanNo: "",
      NameOnPanCard: "",
      GSTNo: "",
      TanNo: "",
      UINNo: "",
      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
    });
  }

  vendorDetails() {
    const { ExternalServicesList, ExternalServicesListTable } = this.state;
    var VendorID = this.props.location.state.VendorID;
    this.setState({ isLoading: true });
    this.props
      .vendor_detail_action(VendorID)
      .then((data) => {
        console.log("Vendor details--------", data);
        if (data.error != 1) {
          this.setState({ isLoading: false });

          const updatedServicePackageList = data.data[2].map((slData) => {
            return {
              ServiceID: slData.ServiceID,
              City: slData.City,
              Package: slData.Package,
              PackageDetails: slData.PackageDetails,
              // Price_In_INR: slData.Price_In_INR,
              // Price_In_USD: slData.Price_In_USD,
              // ITME_CutOff_Limit: slData.ITME_CutOff_Limit,
              ITME_Margin: slData.ITME_Margin,
              packageValue: slData.packageValue,
              previewImagesInput: [],
            };
          });
          console.log("updatedPriceList", updatedServicePackageList);
          this.setState({
            servicePackageList: updatedServicePackageList,
            VendorID: data.data[0][0]["VendorID"],
            password: data.data[0][0]["Password"],
            confPassword: data.data[0][0]["Password"],
            firstName: data.data[0][0]["FirstName"],
            lastName: data.data[0][0]["LastName"],
            designation: data.data[0][0]["Designation"],
            companyName: data.data[0][0]["CompanyName"],
            addressLine1: data.data[0][0]["AddressLine1"],
            addressLine2: data.data[0][0]["AddressLine2"],
            cityId: data.data[0][0]["City"],
            stateId: data.data[0][0]["State"],
            countryId: data.data[0][0]["CountryID"],
            pincode: data.data[0][0]["Pincode"],
            Mobile1: data.data[0][0]["Mobile1"],
            Mobile2: data.data[0][0]["Mobile2"],
            TelephoneNumber: data.data[0][0]["Telephone"],
            primaryEmailID: data.data[0][0]["PrimaryEmailID"],
            secondaryEmailID: data.data[0][0]["SecondaryEmailID"],
            website: data.data[0][0]["Website"],
            registrationNumber: data.data[0][0]["CompanyRegistrationNo"],
            PANCardNo: data.data[0][0]["PanNo"],
            NameonPANCard: data.data[0][0]["NameOnPanCard"],
            GSTNo: data.data[0][0]["GSTNo"],
            TANNumber: data.data[0][0]["TanNo"],
            UINNumber: data.data[0][0]["UINNo"],
            VendorID: data.data[0][0]["VendorID"],
            accountName: data.data[0][0]["AccountName"],
            accountNo: data.data[0][0]["AccountNo"],
            accountType: data.data[0][0]["AccountType"],
            bankName: data.data[0][0]["BankName"],
            branchName: data.data[0][0]["BranchName"],
            IFSCCode: data.data[0][0]["IFSCCode"],
          });
          const operateServicesGetList = data.data[1];
          if (operateServicesGetList != null) {
            const getservicesIdArray = [];
            const newServiceArray = [];
            getservicesIdArray.push(operateServicesGetList);
            getservicesIdArray[0].forEach((data) => {
              newServiceArray.push({
                value: data.ServiceID,
                label: data.ServiceName,
              });
            });

            const materialExtract = data.data[4].map((item) => {
              return {
                VendorServicesMaterialID: item.VendorServicesMaterialID,
                ServiceID: item.ServiceID,
                Name: item.Name,
                Quantity: item.Quantity,
                IsActive: 1,
              };
            });
            this.setState({
              ExternalServicesListTable: newServiceArray,
              vendorServiceList: data.data[1],
              VendorServiceID: data.data[1]["VendorServiceID"],
              ServiceID: data.data[1]["ServiceID"],
              ServiceName: data.data[1]["ServiceName"],
              materialList: materialExtract,
            });
            console.log(
              "newEventArray",
              ExternalServicesListTable,
              materialExtract
            );
          }
          const { countryList, countryId } = this.state;

          setTimeout(() => {
            countryList.map((itme) => {
              if (itme.Countryid == data.data[0]["CountryID"]) {
                this.setState({ ISD: itme.ExtensionCode });
              }
            });
          }, 200);
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  async handleDelete(VendorID, CompanyName) {
    const confirmed = window.confirm(
      `Are you sure you want to delete this Vendor: ${CompanyName}?`
    );

    if (confirmed) {
      await this.props
        .vendor_delete_action(VendorID)
        .then((data) => {
          if (data.error !== 1) {
            setTimeout(() => {
              toast.success(`Vendor: ${CompanyName} Deleted Successfully`, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 1000);
            setTimeout(() => {
              this.props.navigate("/vendor"); // Refresh the holiday list after deletion
            }, 3000);
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }
  handleSubmit(event) {
    event.preventDefault();
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      countryId,
      pincode,
      Mobile1,
      Mobile2,
      TelephoneNumber,
      primaryEmailID,
      secondaryEmailID,
      website,
      cityId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      TANNumber,
      UINNumber,
      VendorID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      companyStatusId,
      password,
      confPassword,
      ExternalServicesListTable,
      servicePackageList,
      VendorServicePackageImageID,
      VendorServiceID,
      FilePath,
      VendorServicePackageID,
      vendorServiceList,
      materialList,
    } = this.state;

    const serviceSelectList = ExternalServicesListTable.map((item, index) => ({
      VendorServiceID: null, // Use the correct property
      ServiceID: item.value,
    }));
    setTimeout(() => {
      this.inputValidate();
    }, 100);
    if (
      firstName != "" &&
      firstName != null &&
      lastName != "" &&
      lastName != null &&
      companyName != "" &&
      companyName != null &&
      addressLine1 != "" &&
      addressLine1 != null &&
      addressLine2 != "" &&
      stateId != null &&
      stateId != "" &&
      addressLine2 != null &&
      countryId != "" &&
      countryId != null &&
      countryId == "91" &&
      countryId != "Country*" &&
      cityId != "" &&
      cityId != null &&
      pincode != "" &&
      pincode != null &&
      primaryEmailID != "" &&
      primaryEmailID != null &&
      PANCardNo != "" &&
      PANCardNo != null &&
      NameonPANCard != "" &&
      NameonPANCard != null &&
      accountName != "" &&
      accountName != null &&
      accountNo != "" &&
      accountNo != null &&
      accountType != "" &&
      accountType != null &&
      accountType != "Select" &&
      accountType != "Account Type*" &&
      bankName != "" &&
      bankName != null &&
      branchName != "" &&
      branchName != null &&
      IFSCCode != "" &&
      IFSCCode != null &&
      password != null &&
      password != "" &&
      confPassword != "" &&
      confPassword != null
    ) {
      var errMsg1 = emailValidator(primaryEmailID);
      var errMsg2 = emailValidator(secondaryEmailID);
      var panErrMsg = panNoValidator(PANCardNo);
      var pincodeErrMsg = pincodeValidator(pincode);
      var mobile1ErrMsg = mobileNoValidator(Mobile1);
      var mobile2ErrMsg = mobileNoValidator(Mobile2);
      var passMsgErr = passwordValidator(password);
      var confPassMsgErr = confirmPasswordValidator(password, confPassword);
      // if(secondaryEmailID!=""||Mobile2!=""){
      //   if(errMsg2!=""||mobile2ErrMsg!=""){
      //     toast.error( errMsg2 != ""
      //     ? errMsg2
      //     : mobile2ErrMsg != ""
      //     ? mobile2ErrMsg:"",{
      //       position:"top-center",
      //       theme: "colored",
      //       autoClose: 1000,
      //       hideProgressBar: true,
      //     })
      //   }
      // }
      if (
        errMsg1 != "" ||
        panErrMsg != "" ||
        pincodeErrMsg != "" ||
        mobile1ErrMsg != "" ||
        passMsgErr != "" ||
        confPassMsgErr != ""
      ) {
        toast.error(
          errMsg1 != ""
            ? errMsg1
            : panErrMsg != ""
              ? panErrMsg
              : pincodeErrMsg != ""
                ? pincodeErrMsg
                : mobile1ErrMsg != ""
                  ? mobile1ErrMsg
                  : passMsgErr != ""
                    ? passMsgErr
                    : confPassMsgErr != ""
                      ? confPassMsgErr
                      : "",
          {
            position: "top-center",
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          }
        );
        if (errMsg1) {
          this.setState({ primaryEmailIDErr: "Please enter proper email" });
        } else if (panErrMsg) {
          this.setState({ PANCardNoErr: "Please enter proper PAN No" });
        } else if (pincodeErrMsg) {
          this.setState({ pincodeErr: "Please Enter proper pincode" });
        } else if (mobile1ErrMsg) {
          this.setState({ Mobile1Err: "Please Enter proper mobile number" });
        }
      } else {
        const packageImageList = [];

        servicePackageList.forEach((item) => {
          if (item.previewImagesInput && item.previewImagesInput.length > 0) {
            item.previewImagesInput.forEach((filePath) => {
              packageImageList.push({
                VendorServicePackageImageID: VendorServicePackageImageID
                  ? VendorServicePackageImageID
                  : 0,
                ServiceID: parseInt(item.ServiceID),
                City: item.City,
                Package: item.Package,
                packageValue: item.packageValue,
                FilePath: filePath,
              });
            });
          } else {
            packageImageList.push({
              VendorServicePackageImageID: VendorServicePackageImageID
                ? VendorServicePackageImageID
                : 0,
              ServiceID: parseInt(item.ServiceID),
              City: item.City,
              Package: item.Package,
              packageValue: item.packageValue,
              FilePath: "", // You can set a default value if FilePath is not present
            });
          }
        });

        const updatedServicePackageList = servicePackageList.map((item) => ({
          VendorServicePackageID: VendorServicePackageID
            ? VendorServicePackageID
            : 0,
          ServiceID: parseInt(item.ServiceID),
          City: item.City,
          Package: item.Package,
          PackageDetails: item.PackageDetails,
          ITME_Margin: item.ITME_Margin,
          packageValue: item.packageValue,
        }));
        const finalMaterialList = materialList.map((item) => ({
          VendorServicesMaterialID:
            item.VendorServicesMaterialID != null ||
              item.VendorServicesMaterialID != ""
              ? item.VendorServicesMaterialID
              : 0,
          ServiceID: item.ServiceID,
          Name: item.Name,
          Quantity: item.Quantity,
          IsActive: item.IsActive == 1 ? true : false,
        }));
        console.log(finalMaterialList, "finalMaterialList");
        if (updatedServicePackageList.length === 0) {
          toast.error("kindly fill the Package Details", {
            position: "top-center",
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          });
        } else {
          this.setState({ isLoading: true });
          this.props
            .vendor_add_action(
              VendorID,
              firstName,
              lastName,
              confPassword,
              designation,
              companyName,
              addressLine1,
              addressLine2,
              cityId,
              stateId,
              countryId,
              pincode,
              Mobile1,
              Mobile2,
              TelephoneNumber,
              primaryEmailID,
              secondaryEmailID,
              website,
              registrationNumber,
              PANCardNo,
              NameonPANCard,
              GSTNo,
              TANNumber,
              UINNumber,
              accountName,
              accountNo,
              accountType,
              bankName,
              branchName,
              IFSCCode,
              serviceSelectList,
              updatedServicePackageList,
              packageImageList,
              finalMaterialList
            )
            .then((data) => {
              if (data.error != 1) {
                this.setState({ isLoading: false }, () => {
                  toast.success(
                    VendorID
                      ? "Vendor Updated Successfully"
                      : "Vendor Submitted Successfully",
                    {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    }
                  );
                  setTimeout(() => {
                    this.navigateBackVendorList();
                  }, 1000); // Adjust the delay time as needed
                });
              } else {
                if (
                  data.msg == sessionExpireMessage ||
                  data.msg == tokenInavlidMessage
                ) {
                  //after session expire.....................
                  sessionStorage.clear();
                  this.props.navigate("/normalView");
                  setTimeout(() => {
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }, 500);
                } else {
                  this.setState({ isLoading: false });
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      }
    } else {
      toast.error("Please enter mandatory fields!", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
      this.setState({ isLoading: false });
    }
  }
  handleAddServicePackage() {
    const { servicePackageList, servicePackageDetails } = this.state;

    const serviceIDCheck = servicePackageDetails.ServiceID;
    const cityCheck = servicePackageDetails.City;
    const packageNameCheck =
      servicePackageDetails.Package.charAt(0).toUpperCase() +
      servicePackageDetails.Package.slice(1);
    if (
      servicePackageList.find(
        (data) =>
          data.Package === packageNameCheck &&
          data.City === cityCheck &&
          data.ServiceID == serviceIDCheck
      )
    ) {
      toast.error("Package already exists for this service and city", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
      });
    } else {
      console.log(this.state.servicePackageDetails.City);
      // Check various conditions before adding the new service package
      if (
        servicePackageDetails.ServiceID === "" ||
        servicePackageDetails.City === "" ||
        servicePackageDetails.Package === "" ||
        servicePackageDetails.PackageDetails === "" ||
        servicePackageDetails.ITME_Margin === "" ||
        servicePackageDetails.packageValue === ""
      ) {
        // Display error messages if any field is empty
        if (servicePackageDetails.ServiceID === "") {
          toast.error("Please select Service Name", {
            position: "top-center",
          });
        }
        if (servicePackageDetails.City === "") {
          toast.error("Please select City Name", {
            position: "top-center",
          });
        }
        if (servicePackageDetails.Package === "") {
          toast.error("Please Enter Package Name", {
            position: "top-center",
          });
        }
        if (servicePackageDetails.PackageDetails === "") {
          toast.error("Please Enter Package Details", {
            position: "top-center",
          });
        }
        if (servicePackageDetails.ITME_Margin === "") {
          toast.error("Please Enter ITME Margin", {
            position: "top-center",
          });
        }
        if (servicePackageDetails.packageValue === "") {
          toast.error("Please Enter Package Value", {
            position: "top-center",
          });
        }
      } else {
        // If all conditions are met, add the new service package to the list
        const newRow = { ...servicePackageDetails };
        this.setState({
          servicePackageList: [...servicePackageList, newRow],
          // Reset the servicePackageDetails state for a new entry
          servicePackageDetails: {
            VendorServicePackageID: null,
            ServiceID: "",
            City: "",
            Package: "",
            PackageDetails: "",
            ITME_Margin: "",
            packageValue: "",
            previewImagesInput: [],
          },
          data: [],
          show: false,
          showImg: false,
        });
        console.log(servicePackageList, servicePackageDetails);
      }
    }
  }

 saveEditedServicePackage(index, VendorServicePackageID) {
  const { servicePackageList, servicePackageDetails } = this.state;
  console.log(index, "index");

  const serviceIDCheck = servicePackageDetails.ServiceID;
  const cityCheck = servicePackageDetails.City;
  const packageNameCheck =
    servicePackageDetails.Package.charAt(0).toUpperCase() +
    servicePackageDetails.Package.slice(1);

  const duplicate = servicePackageList.find(
    (data) =>
      data.Package === packageNameCheck &&
      data.City === cityCheck &&
      data.ServiceID == serviceIDCheck &&
      data.VendorServicePackageID !== servicePackageDetails.VendorServicePackageID // exclude self from duplicate check
  );

  if (duplicate) {
    toastError("Package already exists for this service and city");
    return;
  }

  const updatedList = [...servicePackageList];
  let updateIndex = -1;

  if (VendorServicePackageID && VendorServicePackageID !== 0) {
    // Find by VendorServicePackageID
    updateIndex = updatedList.findIndex(
      (item) => item.VendorServicePackageID === servicePackageDetails.VendorServicePackageID
    );
  } else {
    // Fallback to index
    updateIndex = index;
  }

  if (updateIndex >= 0 && updateIndex < updatedList.length) {
    updatedList[updateIndex] = servicePackageDetails;
  } else {
    toastError("Failed to find the package to update");
    return;
  }

  this.setState(
    {
      servicePackageList: updatedList,
      show: false,
      editIndex: "",
    },
    () => {
      console.log("servicePackageList:", updatedList);
    }
  );
}


  handleDeleteServicePackage(index) {
    const { servicePackageList } = this.state;
    const updatedList = [...servicePackageList];
    const Confirm = window.confirm("Are you sure to remove this Service?");
    if (Confirm) {
      updatedList.splice(index, 1);
      this.setState({
        servicePackageList: updatedList,
      });
    } else {
      return false;
    }
  }
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      packageDemoData: {
        ...prevState.packageDemoData,
        [name]: value,
      },
    }));
  };

  EditModal(index, data) {
    const { ExternalServicesListTable, servicePackageDetails } = this.state;
    this.setState(
      {
        show: true,
        editIndex: index != null ? index : null,
        servicePackageDetails: {
          ...data,
          City: "Mumbai", // Populate the form fields with existing data
        },
      },
      () => {
        console.log(this.state.editIndex, "1234", data); // Check editIndex after state update
      }
    );
  }
  openAddModal() {
    const { ExternalServicesListTable, servicePackageDetails } = this.state;
    if (ExternalServicesListTable.length == 0) {
      toast.error("Kindly select Services", {
        position: "top-center",
      });
    } else {
      this.setState({
        show: true,
        editIndex: "",
        servicePackageDetails: {
          VendorServicePackageID: servicePackageDetails.VendorServicePackageID
            ? servicePackageDetails.VendorServicePackageID : 0,
          ServiceID: "",
          City: "Mumbai",
          Package: "",
          PackageDetails: "",
          ITME_Margin: "",
          packageValue: "",
          previewImagesInput: [],
        },
      });
    }
  }

  modalClose() {
    this.setState({
      show: false,
      servicePackageDetails: {
        ServiceID: "",
        City: "",
        Package: "",
        PackageDetails: "",
        ITME_Margin: "",
        previewImagesInput: [],
        data: "",
        packageValue: "",
      },
    });
  }
  togglePackageDetailsModal(PackageDetails, Package) {
    this.setState((prevState) => ({
      showDetails: !prevState.showDetails,
      showPackageDetails: PackageDetails ? PackageDetails : "",
      Package: Package ? Package : "",
    }));
    console.log(PackageDetails, Package);
  }

  //images
  handleFileChangeService = async (e) => {
    e.preventDefault();
    const files = Array.from(e.target.files);
    console.log(files, "files");
    try {
      // Your file validation logic goes here
      const validFiles = files.filter((file) => {
        // Validate file size and type
        return (
          file.size <= MAX_FILE_SIZE && /\.(jpeg|jpg|png)$/i.test(file.name)
        );
      });

      for (const file of validFiles) {
        const image = await this.resizeFile(file);

        // Update servicePackageDetails with the new image
        this.setState(
          (prevState) => ({
            servicePackageDetails: {
              ...prevState.servicePackageDetails,
              previewImagesInput: [
                ...prevState.servicePackageDetails.previewImagesInput,
                image,
              ],
            },
          }),
          () => {
            console.log(this.state.servicePackageDetails.previewImagesInput);
          }
        );
      }
    } catch (error) {
      console.error("Error handling file selection:", error);
      toast.error("Error handling file selection", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  };

  handleDiscardService = (index) => {
    const { servicePackageDetails } = this.state;
    const updatedPreviewImages = [...servicePackageDetails.previewImagesInput];

    // Remove the image at the specified index
    updatedPreviewImages.splice(index, 1);

    // Update the state with the new preview images array
    this.setState({
      servicePackageDetails: {
        ...servicePackageDetails,
        previewImagesInput: updatedPreviewImages,
      },
    });
  };

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300
      );
    });
  fileName() {
    this.setState({
      fileName: "",
    });
  }
  //Material Checklist
  handleAddRowMaterial() {
    const { materialList, materialDetails } = this.state;
    console.log(materialDetails, materialList, "materialList");

    if (materialDetails.Name === "") {
      toast.error("Please Enter Material Name", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (materialDetails.ServiceID === "") {
      toast.error("Please Select Service", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (materialDetails.Quantity === "") {
      toast.error("Please Enter Quantity", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      const newRow = {
        VendorServicesMaterialID: materialDetails.VendorServicesMaterialID,
        ServiceID: materialDetails.ServiceID,
        Name: materialDetails.Name,
        Quantity: materialDetails.Quantity,
        IsActive: 1,
      };
      this.setState({
        materialList: [...materialList, newRow],
        materialDetails: {
          Name: "",
          ServiceID: "",
          Quantity: "",
          IsActive: null,
        },
        showNewRowMaterial: false, // Hide the "Add" row after adding
      });
    }
  }

  toggleNewRowMaterial() {
    this.setState((prevState) => ({
      showNewRowMaterial: !prevState.showNewRowMaterial,
    }));
  }
  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.handleAddRowMaterial();
    }
  }
  handleEditRowMaterial(index, data) {
    this.setState({
      editedRowIndexMaterial: index,
      editedRowDataMaterial: { ...data },
      materialDetails: { ...data }, // Ensure materialDetails is also updated
    });
  }

  handleRowEditFieldChangeMaterial(index, field, value) {
    const editedDataCopyInclusive = { ...this.state.editedRowDataMaterial };
    editedDataCopyInclusive[field] = value;
    this.setState({ editedRowDataMaterial: editedDataCopyInclusive });
  }
  saveEditedRowMaterial(index) {
    const { materialList, editedRowDataMaterial, materialDetails } = this.state;

    if (editedRowDataMaterial.Name === "") {
      toast.error("Please Enter Material Name", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (
      editedRowDataMaterial.ServiceID === "" ||
      editedRowDataMaterial.ServiceID === "Select" ||
      editedRowDataMaterial.ServiceID === null
    ) {
      toast.error("Please Select Service", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else if (editedRowDataMaterial.Quantity === "") {
      toast.error("Please Enter Quantity", {
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
        position: "top-center",
      });
    } else {
      materialDetails.VendorServicesMaterialID = parseInt(
        materialDetails.VendorServicesMaterialID
      );
      const updatedList = [...materialList];
      updatedList[index] = materialDetails;

      this.setState({
        materialList: updatedList,
        editedRowIndexMaterial: null,
        editedRowDataMaterial: {},
        materialDetails: {
          materialName: "",
          ServiceID: "",
          Quantity: "",
        },
      });
    }
  }

  cancelEditRowMaterial() {
    this.setState({
      editedRowIndexMaterial: null,
      editedRowDataMaterial: {},
    });
  }
  handleDeleteRowMaterial(index) {
    const { materialList } = this.state;
    const updatedList = materialList.map((row, rowIndex) => {
      if (rowIndex === index) {
        return { ...row, IsActive: 0 };
      }
      return row;
    });
    this.setState({
      materialList: updatedList,
    });
  }
  render() {
    const {
      isLoading,
      show,
      showDetails,
      showImg,
      showPackageDetails,
      stateId,
      stateList,
      countryId,
      VendorID,
      countryList,
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      TANNumber,
      UINNumber,
      TelephoneNumber,
      isDisplayCityList,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      accountTypeList,
      firstNameErr,
      lastNameErr,
      VendorErr,
      addressLine1Err,
      addressLine2Err,
      CityNameErr,
      countryIdErr,
      pincodeErr,
      Mobile1Err,
      primaryEmailIDErr,
      PANCardNoErr,
      NameonPANCardErr,
      accountNameErr,
      accountNoErr,
      accountTypeErr,
      bankNameErr,
      branchNameErr,
      IFSCCodeErr,
      stateErr,
      isDisplayStateList,
      TypeOfEventList,
      EventName,
      editedRowIndexServicePackage,
      editedRowServicePackage,
      servicePackageDetails,
      servicePackageList,
      packageValue,
      ServiceID,
      City,
      Package,
      PackageDetails,
      Images,
      Price_In_INR,
      Price_In_USD,
      ITME_CutOff_Limit,
      ITME_Margin,
      password,
      confPassword,
      passwordErr,
      confPasswordErr,
      ExternalServices,
      ExternalServicesID,
      ExternalServicesList,
      ExternalServicesListTable,
      editIndex,
      servicePhotoList,
      previewImagesInput,
      StatusID,
      materialList,
      materialDetails,
      Name,
      showNewRowMaterial,
      editedRowIndexMaterial,
      editedRowDataMaterial,
      vendorServiceList,
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[11]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">
                    {VendorID ? "Edit Vendor" : "Add Vendor"}
                  </h4>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">
                      {VendorID
                        ? StatusID === 1
                          ? "Active"
                          : "Inactive"
                        : "Active"}
                    </h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                        {VendorID ? (
                          <>
                            <input
                              type="checkbox"
                              checked={StatusID === 1}
                              onChange={() => {
                                this.setState((prevState) => ({
                                  StatusID: prevState.StatusID === 1 ? 0 : 1,
                                }));
                              }}
                            />
                            <span className="slider round"></span>
                          </>
                        ) : (
                          <>
                            <input type="checkbox" checked={true} readOnly />
                            <span className="slider round"></span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card Service_fields">
                  <div className="card-body">
                    <div className="company_info">
                      <fieldset>
                        <legend>Name and full address of the Vendor</legend>
                        <div className="outside_input_field ">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={companyName}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={100}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.VendorName(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {VendorErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Vendor Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={password}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={30}
                                    onChange={(e) => this.password(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {passwordErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Password{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={confPassword}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.confPassword(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {confPasswordErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Confirm Password{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={firstName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    maxLength={30}
                                    onChange={(e) => this.firstName(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {firstNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    First Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={lastName}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={30}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.lastName(e)}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {lastNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Last Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={designation}
                                    type="text"
                                    class="outside"
                                    required
                                    maxLength={50}
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.designation(e)}
                                  />
                                  <span class="floating-label-outside">
                                    Designation
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group floating-group floating-diff">
                                <label class="floating-label">COUNTRY </label>
                                <select
                                  id="state"
                                  name="Entry Type"
                                  className="form-control floating-control"
                                  value={91}
                                  disabled
                                >
                                  <option value="" disabled>
                                    Country{" "}
                                    <span className="mendatory_class">*</span>
                                  </option>
                                  {countryList.length > 0 &&
                                    countryList.map((item) => (
                                      <option
                                        key={item.Countryid}
                                        value={item.Countryid}
                                        disabled={item.Countryid === "91"}
                                      >
                                        {item.CountryName}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={stateId}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.onStateSearch(e)}
                                    autocomplete="off"
                                    maxLength={30}
                                  />
                                  {isDisplayStateList && this.renderStateList()}
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {stateErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    State Name
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={cityId}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.onCitytSearch(e)}
                                    autocomplete="off"
                                    maxLength={30}
                                  />
                                  {isDisplayCityList && this.renderCityList()}
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {CityNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    City Name
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={addressLine1}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.addressLine1(e)}
                                    maxLength={70}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {addressLine1Err}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Address Line 1{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={addressLine2}
                                    type="text"
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    class="outside"
                                    required
                                    onChange={(e) => this.addressLine2(e)}
                                    maxLength={70}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {addressLine2Err}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Address Line 2{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={pincode}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.pincode(e)}
                                    maxLength={20}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {pincodeErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    {countryId == "91" ||
                                      countryId == "" ||
                                      countryId == "Country*"
                                      ? "Pincode"
                                      : "ZipCode"}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder="ISD"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      value={ISD}
                                      disabled={true}
                                    />
                                  </div>
                                  <div class="position-relative width_80">
                                    <input
                                      value={Mobile1}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.mobile1(e)}
                                      maxLength={10}
                                    />
                                    {
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {Mobile1Err}
                                      </span>
                                    }
                                    <span class="floating-label-outside">
                                      Mobile 1{" "}
                                      <span class="mendatory_class">*</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder="ISD"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      value={ISD}
                                      disabled={true}
                                    />
                                  </div>
                                  <div class="position-relative width_80">
                                    <input
                                      value={Mobile2}
                                      type="text"
                                      class="outside"
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.mobile2(e)}
                                      maxLength={10}
                                    />
                                    <span class="floating-label-outside">
                                      Mobile 2
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="tel_number">
                                  <div class="ISD">
                                    <input
                                      type="text"
                                      class="outside"
                                      placeholder="ISD"
                                      value={ISD}
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      disabled={true}
                                    />
                                  </div>
                                  {/* <div class="STD">
                                                                                <input type="text" class="outside" placeholder="STD" value={STD} required
                                                                                    onChange={(e) => this.setState({ STD: e.target.value })}
                                                                                />
                                                                            </div> */}
                                  <div class="position-relative width_80">
                                    <input
                                      type="text"
                                      class="outside"
                                      value={TelephoneNumber}
                                      required
                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                      onChange={(e) => this.telephone(e)}
                                      maxLength={16}
                                    />
                                    <span class="floating-label-outside">
                                      Telephone Number
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={primaryEmailID}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.primaryEmail(e)}
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {primaryEmailIDErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Primary Email ID{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={secondaryEmailID}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.secondaryEmail(e)}
                                    maxLength={50}
                                  />
                                  <span class="floating-label-outside">
                                    Secondary Email ID{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={website}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => this.website(e)}
                                    maxLength={40}
                                  />
                                  <span class="floating-label-outside">
                                    Website{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend>Vendor's N Information</legend>
                        <div class="outside_input_field ">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={registrationNumber}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        registrationNumber:
                                          e.target.value.toUpperCase(),
                                      })
                                    }
                                    maxLength={20}
                                  />
                                  <span class="floating-label-outside">
                                    Registration Number{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={PANCardNo}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => {
                                      this.setState({
                                        PANCardNo: e.target.value.toUpperCase(),
                                        PANCardNoErr: "",
                                      });
                                    }}
                                    maxLength={10}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {PANCardNoErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    PAN Card No.{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={NameonPANCard}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      // Regex pattern to allow only alphabetic characters
                                      const regex = /^[a-zA-Z\s]*$/;
                                      // Check if the input value matches the pattern
                                      if (regex.test(inputValue)) {
                                        this.setState({
                                          NameonPANCard: e.target.value
                                            .split(" ")
                                            .map(
                                              (word) =>
                                                word.charAt(0).toUpperCase() +
                                                word.slice(1)
                                            )
                                            .join(" "),
                                          NameonPANCardErr: "",
                                        });
                                      } else {
                                        toast.error("Numbers not allowed", {
                                          position: "top-center",
                                          autoClose: 1000,
                                        });
                                      }
                                    }}
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {NameonPANCardErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Name on PAN Card{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={GSTNo}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        GSTNo: e.target.value.toUpperCase(),
                                      })
                                    }
                                  />
                                  <span class="floating-label-outside">
                                    GST No.{" "}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={TANNumber}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        TANNumber: e.target.value.toUpperCase(),
                                      })
                                    }
                                    maxLength={20}
                                  />
                                  <span class="floating-label-outside">
                                    TAN Number{" "}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={UINNumber}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        UINNumber: e.target.value.toUpperCase(),
                                      })
                                    }
                                    maxLength={20}
                                  />
                                  <span class="floating-label-outside">
                                    UIN Number{" "}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend>Banking details</legend>
                        <div class="outside_input_field ">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={accountName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        accountName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        accountNameErr: "",
                                      })
                                    }
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {accountNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Account Name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={accountNo}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        accountNo: e.target.value.replace(
                                          /\D/,
                                          ""
                                        ),
                                        accountNoErr: "",
                                      })
                                    }
                                    maxLength={30}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {accountNoErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Account No.{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group floating-group floating-diff">
                                <select
                                  id="state"
                                  name="Entry Type"
                                  class="form-control floating-control"
                                  value={accountType}
                                  onChange={(e) =>
                                    this.setState({
                                      accountType: e.target.value,
                                      accountTypeErr: "",
                                    })
                                  }
                                >
                                  <option>
                                    Account Type
                                    <span class="mendatory_class">*</span>
                                  </option>

                                  {accountTypeList.length > 0 &&
                                    accountTypeList.map((item) => (
                                      <option>{item.Accounttype}</option>
                                    ))}
                                </select>
                                {
                                  <span className="text-danger text-start text-left d-block mt-1">
                                    {accountTypeErr}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={bankName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        bankName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        bankNameErr: "",
                                      })
                                    }
                                    maxLength={50}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {bankNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    Bank name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={branchName}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        branchName: e.target.value
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" "),
                                        branchNameErr: "",
                                      })
                                    }
                                    maxLength={30}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {branchNameErr}
                                    </span>
                                  }
                                  <span class="floating-label-outside">
                                    branch name{" "}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <input
                                    value={IFSCCode}
                                    type="text"
                                    class="outside"
                                    required
                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                    onChange={(e) =>
                                      this.setState({
                                        IFSCCode: e.target.value.toUpperCase(),
                                        IFSCCodeErr: "",
                                      })
                                    }
                                    maxLength={20}
                                  />
                                  {
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      {IFSCCodeErr}
                                    </span>
                                  }

                                  <span class="floating-label-outside">
                                    {countryId == "91" ||
                                      countryId == "" ||
                                      countryId == "Country*"
                                      ? "IFSC code"
                                      : "Swift code"}
                                    <span class="mendatory_class">*</span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend>Service Offered</legend>
                        <div class="outside_input_field ">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <div class="position-relative">
                                  <div class="form-group floating-group floating-diff">
                                    <label>Services</label>
                                    <Select
                                      isMulti
                                      value={
                                        ExternalServices ||
                                        ExternalServicesListTable
                                      }
                                      isClearable={
                                        servicePackageList.length > 0
                                          ? false
                                          : true
                                      }
                                      onChange={(selectedOptions) => {
                                        if (
                                          !selectedOptions ||
                                          selectedOptions.length === 0
                                        ) {
                                          const confirmed = window.confirm(
                                            "Are you sure you want to clear the selection? This might remove the Service Packages."
                                          );
                                          if (confirmed) {
                                            console.log("Selection cleared");
                                            // Remove the same service from ExternalServicesList if present
                                            const updatedList =
                                              ExternalServicesList.filter(
                                                (option) =>
                                                  !ExternalServices ||
                                                  !ExternalServices.some(
                                                    (service) =>
                                                      service.value ===
                                                      option.value
                                                  )
                                              );
                                            this.setState({
                                              ExternalServices: [],
                                              ExternalServicesListTable: [],
                                              servicePackageList: [],
                                              ExternalServicesList: updatedList, // Update the state with the modified list
                                            });
                                          }
                                        } else if (
                                          selectedOptions.length <= 2
                                        ) {
                                          this.setState({
                                            ExternalServices: selectedOptions,
                                            ExternalServicesListTable:
                                              selectedOptions,
                                          });
                                        } else {
                                          toast.error(
                                            "Maximum 2 services are allowed",
                                            {
                                              position: "top-center",
                                              theme: "colored",
                                              autoClose: 3000,
                                            }
                                          );
                                        }
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Backspace") {
                                          e.preventDefault(); // Prevent the default behavior of backspace
                                        }
                                      }}
                                      styles={customStyles}
                                      options={
                                        ExternalServicesList &&
                                        ExternalServicesList.filter(
                                          (option) => option && option.label
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div className="col-md-12">
                              <table
                                class="table table-bordered table-striped"
                                id="tbl"
                              >
                                <thead>
                                  <tr className="text-center">
                                    <th>SERVICE</th>
                                    <th>CITY</th>
                                    <th>PACKAGE</th>
                                    {/* <th>PACKAGE DETAILS</th> */}
                                    {/* <th>IMAGES</th> */}
                                    <th>ITME MARGIN %</th>
                                    <th>ACTION</th>
                                  </tr>
                                </thead>
                                <tbody id="myTable">
                                  {servicePackageList.length > 0 ? (
                                    servicePackageList.map((data, index) => (
                                      <tr key={index} className="text-center">
                                        <td>
                                          {ExternalServicesListTable.find(
                                            (service) =>
                                              service.value ===
                                              parseInt(data.ServiceID)
                                          ).label || data.ServiceID}
                                        </td>
                                        <td>
                                          {cityList.find(
                                            (city) =>
                                              city.CityName === data.City
                                          )?.CityName || ""}
                                        </td>
                                        <td>{data.Package}</td>
                                        {/* <td className="text-center">
                                          <i
                                            className="fa fa-table action_btn_table"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.togglePackageDetailsModal(
                                                data.PackageDetails,
                                                data.Package
                                              )
                                            }
                                          ></i>
                                        </td>
                                        <td className="text-center">
                                          <i className="fa fa-image action_btn_table"></i>
                                        </td> */}
                                        <td className="text-center">
                                          {data.ITME_Margin}
                                        </td>
                                        <td className="text-center">
                                          <a
                                            title="Edit"
                                            className="btn btn-sm padding_0"
                                            onClick={() =>
                                              this.EditModal(index, data)
                                            }
                                          >
                                            <i className="fa fa-edit action_btn_table" />
                                          </a>
                                          <a
                                            title="Delete"
                                            className="btn btn-sm delete_record padding_0"
                                            onClick={() =>
                                              this.handleDeleteServicePackage(
                                                index
                                              )
                                            }
                                          >
                                            <i className="fa fa-trash action_btn_table" />
                                          </a>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="8">No data available.</td>
                                    </tr>
                                  )}{" "}
                                </tbody>
                              </table>
                              <a
                                href="javascript:void(0);"
                                className="btn btn-primary btn-sm create_btn add_Quantity_btn mb-3"
                                style={{ width: "auto" }}
                                // onClick={() => this.toggleNewServicePackage()}
                                onClick={() => this.openAddModal()}
                              >
                                <i className="fa fa-plus" />{" "}
                                <span className="hidden-xs">
                                  Add Service Package
                                </span>
                              </a>
                              <Modal
                                show={show}
                                // onHide={this.modalClose}
                                size="lg"
                              >
                                <Modal.Header>
                                  <Modal.Title>Add Services</Modal.Title>
                                  <span
                                    onClick={() => this.modalClose()}
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: "800",
                                    }}
                                  >
                                    X
                                  </span>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className="modal-body">
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <label>
                                            Services{" "}
                                            <span className="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            className="form-control"
                                            name="Service"
                                            value={
                                              servicePackageDetails.ServiceID
                                            }
                                            onChange={(e) => {
                                              const selectedServiceID =
                                                e.target.value;
                                              this.setState({
                                                servicePackageDetails: {
                                                  ...servicePackageDetails,
                                                  ServiceID: selectedServiceID,
                                                },
                                              });
                                            }}
                                          >
                                            <option value="">--Select--</option>
                                            {ExternalServicesListTable.map(
                                              (data) => (
                                                <option
                                                  key={data.value}
                                                  value={data.value}
                                                >
                                                  {`${data.label}`}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="form-group">
                                          <label>
                                            City{" "}
                                            <span className="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            className="form-control"
                                            name="Service"
                                            value="Mumbai" // Set the default value to "Mumbai"
                                            disabled // Disable the select field
                                          >
                                            <option>Mumbai</option>
                                            {/* {cityList.map((data) => (
          <option
            key={data.Code}
            value={data.CityName}
          >
            {`${data.CityName}`}
          </option>
        ))} */}
                                          </select>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            Package{" "}
                                            <span className="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Package"
                                            name="name"
                                            value={
                                              servicePackageDetails.Package
                                            }
                                            onChange={(e) => {
                                              const newPackage =
                                                e.target.value
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                e.target.value.slice(1);
                                              this.setState({
                                                servicePackageDetails: {
                                                  ...servicePackageDetails,
                                                  Package: newPackage,
                                                },
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            ITME Margin %{" "}
                                            <span className="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={
                                              servicePackageDetails.ITME_Margin
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;

                                              const numericValue = value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1");
                                              this.setState({
                                                servicePackageDetails: {
                                                  ...servicePackageDetails,
                                                  ITME_Margin: numericValue,
                                                },
                                              });
                                            }}
                                            placeholder="ITME Margin %"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            Package Value{" "}
                                            <span className="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={
                                              servicePackageDetails.packageValue
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;

                                              const numericValue = value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1");
                                              this.setState({
                                                servicePackageDetails: {
                                                  ...servicePackageDetails,
                                                  packageValue: numericValue,
                                                },
                                              });
                                            }}
                                            placeholder="Package Value"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="App col-md-12">
                                        <div className="form-group">
                                          <label>
                                            Package Details{" "}
                                            <span className="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <CKEditor
                                            editor={ClassicEditor}
                                            data={
                                              servicePackageDetails.PackageDetails
                                            }
                                            config={{
                                              editorConfiguration: {
                                                fontFamily: {
                                                  options: ['default', 'Open Sans, sans-serif', 'Arial, sans-serif', 'Georgia, serif', 'Verdana, sans-serif']
                                                }
                                              }
                                            }}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              this.setState({
                                                servicePackageDetails: {
                                                  ...servicePackageDetails,
                                                  PackageDetails: data,
                                                },
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    {/* <div>
                                      <pre
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            servicePackageDetails.PackageDetails,
                                        }}
                                      />
                                    </div> */}

                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <div className="upload__box">
                                            <div className="upload__btn-box">
                                              <label className="upload__btn">
                                                <p>
                                                  Upload Photos{" "}
                                                  <span className="upload_size">
                                                    ( Max 10 Photos, Max 2MB
                                                    each )
                                                  </span>
                                                </p>
                                                <input
                                                  type="file"
                                                  data-max-length="10"
                                                  data-max-size="2MB"
                                                  className="upload__inputfile"
                                                  onChange={(e) =>
                                                    this.handleFileChangeService(
                                                      e
                                                    )
                                                  }
                                                  accept=".jpeg, .jpg, .png"
                                                  multiple
                                                />
                                              </label>
                                            </div>
                                            {servicePackageDetails.previewImagesInput.length >
                                              0 && (
                                                <div className="upload__img-wrap">
                                                  {servicePackageDetails.previewImagesInput.map(
                                                    (image, index) => (
                                                      <div
                                                        key={index}
                                                        className="uploaded-image"
                                                        style={{
                                                          position: "relative",
                                                          display: "inline-block",
                                                          margin: "0.8rem",
                                                          marginRight: "10px",
                                                          marginBottom: "10px",
                                                        }}
                                                      >
                                                        <img
                                                          src={image}
                                                          alt={`Preview ${index}`}
                                                          style={{
                                                            width: "200px",
                                                            height: "200px",
                                                          }}
                                                        />
                                                        <span
                                                          style={{
                                                            backgroundColor: "grey",
                                                            color: "black",
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            top: "5px",
                                                            right: "5px",
                                                            padding: "4px 8px",
                                                            borderRadius: "50%",
                                                          }}
                                                          onClick={() =>
                                                            this.handleDiscardService(
                                                              index
                                                            )
                                                          }
                                                          className="uploaded-image__discard-btn"
                                                        >
                                                          X
                                                        </span>
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              )}

                                            {/* {VendorID ? (
                                              <div className="upload__img-wrap">
                                                {servicePhotoList.map(
                                                  (imageName, index) => (
                                                    <div
                                                      key={index}
                                                      className="uploaded-image"
                                                      style={{
                                                        display: "flex",
                                                        margin: "0.8rem",
                                                        marginRight: "10px",
                                                        marginBottom: "10px",
                                                        borderRadius: "14px",
                                                        padding: "8px",
                                                        backgroundColor:
                                                          "#00BCD4",
                                                        color: "white",
                                                      }}
                                                    >
                                                      <div className="chip">
                                                        {imageName}
                                                      </div>
                                                      <span
                                                        className="chip__discard-btn"
                                                        onClick={() =>
                                                          this.handleDiscardCenter(
                                                            index
                                                          )
                                                        }
                                                        style={{
                                                          paddingLeft: "6px",
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        X
                                                      </span>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            ) : null} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Body>
                                <Modal.Footer>
                                  {console.log(editIndex, servicePackageDetails, "modal")}
                                  {editIndex === null || editIndex === "" ? (
                                    <Button
                                      variant="success"
                                      onClick={() =>
                                        this.handleAddServicePackage()
                                      }
                                    >
                                      Save changes
                                    </Button>
                                  ) : (
                                    <Button
                                      variant="success"
                                      onClick={() =>
                                        this.saveEditedServicePackage(editIndex, servicePackageDetails.VendorServicePackageID)
                                      }
                                    >
                                      Save changes
                                    </Button>
                                  )}

                                  <Button
                                    variant="secondary"
                                    onClick={() => this.modalClose()}
                                  >
                                    {" "}
                                    Cancel
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                              <Modal
                                show={showDetails}
                                // onHide={this.togglePackageDetailsModal}
                                size="lg"
                              >
                                <Modal.Header>
                                  <Modal.Title>{Package}</Modal.Title>
                                  <span
                                    onClick={() =>
                                      this.togglePackageDetailsModal()
                                    }
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: "800",
                                    }}
                                  >
                                    X
                                  </span>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className="modal-body">
                                    <div>
                                      <pre
                                        dangerouslySetInnerHTML={{
                                          __html: showPackageDetails,
                                        }}
                                      />
                                    </div>
                                  </div>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button
                                    variant="secondary"
                                    onClick={() =>
                                      this.togglePackageDetailsModal()
                                    }
                                  >
                                    {" "}
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <fieldset>
                        <legend>Material Wise List</legend>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="custom_table">
                                  <div class="hack1">
                                    <div class="hack2">
                                      <table
                                        class="table table-bordered table-striped"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10%" }}>
                                              Sr. no
                                            </th>
                                            <th style={{ width: "30%" }}>
                                              Service Name
                                            </th>
                                            <th style={{ width: "30%" }}>
                                              Material Name
                                            </th>
                                            <th style={{ width: "20%" }}>
                                              Quantity
                                            </th>
                                            <th
                                              class="text-right"
                                              style={{ width: "10%" }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody id="myTable">
                                          {materialList.length > 0 ? (
                                            materialList
                                              .filter(
                                                (data) => data.IsActive == 1
                                              )
                                              .map((data, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    {this.state
                                                      .editedRowIndexMaterial ===
                                                      index ? (
                                                      <select
                                                        className="form-control"
                                                        name="Service"
                                                        value={
                                                          this.state
                                                            .editedRowDataMaterial
                                                            .ServiceID || ""
                                                        }
                                                        onChange={(e) => {
                                                          const selectedServiceID =
                                                            e.target.value;
                                                          this.setState(
                                                            (prevState) => ({
                                                              editedRowDataMaterial:
                                                              {
                                                                ...prevState.editedRowDataMaterial,
                                                                ServiceID:
                                                                  selectedServiceID,
                                                              },
                                                            })
                                                          );
                                                        }}
                                                      >
                                                        <option value="">
                                                          --Select--
                                                        </option>
                                                        {ExternalServicesListTable.map(
                                                          (data) => (
                                                            <option
                                                              key={data.value}
                                                              value={data.value}
                                                            >
                                                              {`${data.label}`}
                                                            </option>
                                                          )
                                                        )}
                                                      </select>
                                                    ) : (
                                                      (() => {
                                                        const externalServiceData =
                                                          ExternalServicesList.find(
                                                            (item) =>
                                                              item.value ===
                                                              parseInt(
                                                                data.ServiceID
                                                              )
                                                          );
                                                        return externalServiceData
                                                          ? `${externalServiceData.label}`
                                                          : "";
                                                      })()
                                                    )}
                                                  </td>
                                                  <td>
                                                    {this.state
                                                      .editedRowIndexMaterial ===
                                                      index ? (
                                                      <input
                                                        className="form-control"
                                                        value={
                                                          this.state
                                                            .editedRowDataMaterial
                                                            .Name || ""
                                                        }
                                                        onChange={(e) =>
                                                          this.setState(
                                                            (prevState) => ({
                                                              editedRowDataMaterial:
                                                              {
                                                                ...prevState.editedRowDataMaterial,
                                                                Name: e.target
                                                                  .value,
                                                              },
                                                            })
                                                          )
                                                        }
                                                      />
                                                    ) : (
                                                      data.Name
                                                    )}
                                                  </td>
                                                  <td>
                                                    {this.state
                                                      .editedRowIndexMaterial ===
                                                      index ? (
                                                      <input
                                                        className="form-control"
                                                        value={
                                                          this.state
                                                            .editedRowDataMaterial
                                                            .Quantity || ""
                                                        }
                                                        onChange={(e) => {
                                                          const value =
                                                            e.target.value;

                                                          const numericValue =
                                                            value
                                                              .replace(
                                                                /[^0-9.]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /(\..*)\./g,
                                                                "$1"
                                                              );
                                                          this.setState(
                                                            (prevState) => ({
                                                              editedRowDataMaterial:
                                                              {
                                                                ...prevState.editedRowDataMaterial,
                                                                Quantity:
                                                                  numericValue,
                                                              },
                                                            })
                                                          );
                                                        }}
                                                      />
                                                    ) : (
                                                      data.Quantity
                                                    )}
                                                  </td>
                                                  <td className="text-right">
                                                    {this.state
                                                      .editedRowIndexMaterial ===
                                                      index ? (
                                                      <>
                                                        <a
                                                          title="Save"
                                                          className="btn btn-sm padding_0"
                                                          onClick={() =>
                                                            this.saveEditedRowMaterial(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <i className="fa fa-save action_btn_table" />
                                                        </a>
                                                        <a
                                                          title="Cancel"
                                                          className="btn btn-sm padding_0"
                                                          onClick={() =>
                                                            this.cancelEditRowMaterial()
                                                          }
                                                        >
                                                          <i className="fa fa-times action_btn_table" />
                                                        </a>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <a
                                                          title="Edit"
                                                          className="btn btn-sm padding_0"
                                                          onClick={() =>
                                                            this.handleEditRowMaterial(
                                                              index,
                                                              data
                                                            )
                                                          }
                                                        >
                                                          <i className="fa fa-edit action_btn_table" />
                                                        </a>
                                                        <a
                                                          title="Delete"
                                                          className="btn btn-sm delete_record padding_0"
                                                          onClick={() =>
                                                            this.handleDeleteRowMaterial(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <i className="fa fa-trash action_btn_table" />
                                                        </a>
                                                      </>
                                                    )}
                                                  </td>
                                                </tr>
                                              ))
                                          ) : (
                                            <tr>
                                              <td colSpan="6">
                                                No data available.
                                              </td>
                                            </tr>
                                          )}
                                          {showNewRowMaterial && (
                                            <tr>
                                              <td></td>
                                              <td>
                                                <select
                                                  className="form-control"
                                                  name="Service"
                                                  value={
                                                    materialDetails.ServiceID
                                                  }
                                                  onChange={(e) => {
                                                    const selectedServiceID =
                                                      e.target.value;
                                                    this.setState({
                                                      materialDetails: {
                                                        ...materialDetails,
                                                        ServiceID:
                                                          selectedServiceID,
                                                      },
                                                    });
                                                  }}
                                                >
                                                  <option value="">
                                                    --Select--
                                                  </option>
                                                  {ExternalServicesListTable.map(
                                                    (data) => (
                                                      <option
                                                        key={data.value}
                                                        value={data.value}
                                                      >
                                                        {`${data.label}`}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={materialDetails.Name}
                                                  onChange={(e) =>
                                                    this.setState({
                                                      materialDetails: {
                                                        ...materialDetails,
                                                        Name: e.target.value,
                                                      },
                                                    })
                                                  }
                                                  placeholder="Material Name"
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  className="form-control"
                                                  value={
                                                    materialDetails.Quantity
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    const numericValue = value
                                                      .replace(/[^0-9.]/g, "")
                                                      .replace(
                                                        /(\..*)\./g,
                                                        "$1"
                                                      );
                                                    this.setState({
                                                      materialDetails: {
                                                        ...materialDetails,
                                                        Quantity: numericValue,
                                                      },
                                                    });
                                                  }}
                                                  placeholder="Material Name"
                                                />
                                              </td>
                                              <td>
                                                <button
                                                  className="btn btn-primary btn-md"
                                                  onClick={() =>
                                                    this.handleAddRowMaterial()
                                                  }
                                                >
                                                  Add
                                                </button>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <div>
                                        <a
                                          href="javascript:void(0);"
                                          class="btn btn-primary btn-sm create_btn add_additional_days_btn mb-3"
                                          style={{ width: "auto" }}
                                          onClick={() =>
                                            this.toggleNewRowMaterial()
                                          }
                                        >
                                          <span class="hidden-xs">
                                            {showNewRowMaterial
                                              ? "Cancel"
                                              : "Add"}
                                          </span>
                                        </a>
                                        {/* <button type="button" class="delete-row">Delete Row</button> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </fieldset>
                      <div className="row">
                        <div className="mx-3">
                          <a
                            href="javascript:void(0);"
                            onClick={(e) => this.handleSubmit(e)}
                            className="btn btn-success px-4"
                          >
                            {VendorID ? "Update" : "Save"}
                          </a>
                        </div>
                        {VendorID ? (
                          <div className="mx-2">
                            <a
                              href="javascript:void(0);"
                              onClick={() =>
                                this.handleDelete(VendorID, companyName)
                              }
                              className="btn btn-danger px-4"
                            >
                              Delete
                            </a>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div className="mx-3">
                          <a
                            href="javascript:void(0);"
                            onClick={() => this.navigateBackVendorList()}
                            className="btn btn-secondary px-4"
                          >
                            Back
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    vendor_add_action,
    vendor_detail_action,
    vendor_delete_action,
  })(VendorAU)
);
